const paperList = () => import('./paperList');
const paperDetail = () => import('./paperDetail');
const paperTemList = () => import('./paperTemList');
const paperPreview = () => import('./paperPreview');
const practiceManagement = () => import('./practiceManagement');
const examManage = () => import('./examManage');
const setExam = () => import('./setExam');
const classificationManagement = () => import('./classificationManagement');

const paper = [
  {
    path: 'testPaperManagement',
    name: 'paperList',
    component: paperList,
    meta: {
      title: '试卷管理',
    },
  },
  // TODO paperList
  {
    path: 'paperList',
    name: 'paperList',
    component: paperList,
    meta: {
      title: '试卷管理',
    },
  },
  {
    path: 'paperDetail',
    name: 'paperDetail',
    component: paperDetail,
    meta: {
      title: '试卷信息',
    },
  },
  {
    path: 'paperTemList',
    name: 'paperTemList',
    component: paperTemList,
    meta: {
      title: '模版管理',
    },
  },
  {
    path: 'paperPreview',
    name: 'paperPreview',
    component: paperPreview,
    meta: {
      title: '试卷预览',
    },
  },
  {
    path: 'practiceManagement',
    name: 'practiceManagement',
    component: practiceManagement,
    meta: {
      title: '练习管理',
    },
  },
  {
    path: 'setExam',
    name: 'setExam',
    component: setExam,
    meta: {
      title: '设置试卷',
    },
  },
  {
    path: 'examManage',
    name: 'examManage',
    component: examManage,
    meta: {
      title: '考试管理',
    },
  },
  {
    path: 'classificationManagement',
    name: 'classificationManagement',
    component: classificationManagement,
    meta: {
      title: '分类管理',
    },
  },
];
export default paper;
